export default __webpack_public_path__ + "static/media/lu.4eb48b3c.svg";